import { removeEmptyKeys, isValueOrUndefined, getFirstMatchingValue } from '../../utils';
import styles from './index.module.css';
const possibleProps = [-11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 'auto'];
const withPrefix = val => {
  if (val < 0) {
    return `Negative${Math.abs(val)}`;
  }
  return val;
};

/**
 * @typedef { -11 | -10 | -9 | -8 | -7 | -6 | -5 | -4 | -3 | -2 | -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 'auto' } m
 * @typedef { -11 | -10 | -9 | -8 | -7 | -6 | -5 | -4 | -3 | -2 | -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 'auto' } mb
 * @typedef { -11 | -10 | -9 | -8 | -7 | -6 | -5 | -4 | -3 | -2 | -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 'auto' } ml
 * @typedef { -11 | -10 | -9 | -8 | -7 | -6 | -5 | -4 | -3 | -2 | -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 'auto' } mr
 * @typedef { -11 | -10 | -9 | -8 | -7 | -6 | -5 | -4 | -3 | -2 | -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 'auto' } mt
 * @typedef { -11 | -10 | -9 | -8 | -7 | -6 | -5 | -4 | -3 | -2 | -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 'auto' } mx
 * @typedef { -11 | -10 | -9 | -8 | -7 | -6 | -5 | -4 | -3 | -2 | -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 'auto' } my
 */

/**
 * @param m {m}
 * @param mb {mb}
 * @param ml {ml}
 * @param mr {mr}
 * @param mt {mt}
 * @param mx {mx}
 * @param my {my}
 *
 * @returns [className]
 */
const getMargin = (m, mb, ml, mr, mt, mx, my) => {
  const marginBottom = getFirstMatchingValue(possibleProps, [mb, my, m]);
  const marginLeft = getFirstMatchingValue(possibleProps, [ml, mx, m]);
  const marginRight = getFirstMatchingValue(possibleProps, [mr, mx, m]);
  const marginTop = getFirstMatchingValue(possibleProps, [mt, my, m]);
  const classnames = removeEmptyKeys({
    // margin
    [styles[`marginBottom${withPrefix(marginBottom)}`]]: isValueOrUndefined(marginBottom),
    [styles[`marginLeft${withPrefix(marginLeft)}`]]: isValueOrUndefined(marginLeft),
    [styles[`marginRight${withPrefix(marginRight)}`]]: isValueOrUndefined(marginRight),
    [styles[`marginTop${withPrefix(marginTop)}`]]: isValueOrUndefined(marginTop)
  });

  /**
   * We return an array and not an object, for renaming reasons.
   */
  return [classnames];
};
export default getMargin;